export default "__VITE_ASSET__pYcTajdT__"